import React from "react";
import YoutubeIcon from "./youtube.icon";
import BackgroundImage from "src/components/backgroundImage/backgroundImage.v1";

type YoutubeFacadeProps = {
    id: string;
}

export default class YoutubeFacade extends React.Component<YoutubeFacadeProps> {
    render(): React.ReactNode {
        const id = this.props.id;

        return <div className="iframe-frame">
            <div className="aspect-video relative cursor-pointer">
                <BackgroundImage mobileContain className="h-full w-full iframe-frame" src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} />
                <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                    <div className="w-20">
                        <YoutubeIcon />
                    </div>
                </div>
            </div>
        </div>
    }
}